<div class="sync-spinner-content">
  <img src="assets/icons/logo-mw.svg" alt="Logo Music Work">
  <p *ngIf="downloading && !syncing && !ended" class="sync-written-status">{{'sync-progress.downloading' | translate}}</p>
  <p *ngIf="syncing && !downloading && !ended" class="sync-written-status">{{'sync-progress.sync' | translate}}</p>
  <p *ngIf="ended" class="sync-written-status" id="sync-written-success">{{'sync-progress.success' | translate}}</p>
  <p *ngIf="error" class="sync-written-status">{{'sync-progress.error' | translate}}</p>
  <svg class="sync-progress-spinner" xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 144 145">
    <!-- Cercle de fond gris -->
    <circle cx="72" cy="72.2011" r="65" fill="none" stroke="#D9D9D9" stroke-width="15" />
    <!-- Cercle de remplissage vert -->
    <circle cx="72" cy="72.2011" r="65" fill="none" [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="offset" [ngStyle]="{ 'stroke': error ? '#FF0000' : '#99D18C', 'stroke-width': '15' }" />
  </svg>
</div>
